// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestContent } from './secondOpinionActions';
import {
  updateObservations,
  requestObservationsUpdate,
} from 'ducks/coreDataActions';
import {
  PowerReviewsModerationCard,
  PowerReviewsKeyboardEnchancer,
} from 'components';
import type { State as SecondOpinionReducerState } from './secondOpinionReducer';
import styles from './SecondOpinion.scss';
import { type Product, ModerationState } from 'models';
import ContentRequest from 'pages/__components__/ContentRequest';
import ContentResponse from 'pages/__components__/ContentResponse';
import { CoreDataState } from 'ducks/coreDataReducer';
import secondOpinionReducer from './secondOpinionReducer';
import secondOpinionSaga from './secondOpinionSaga';
import HideClientSelect from 'containers/client/HideClientSelectMenu';

import { injectSaga, injectReducer } from 'store';
injectSaga(secondOpinionSaga);
injectReducer({ secondOpinion: secondOpinionReducer });

type SecondOpinionProps = {
  contentRequestStatus: RequestStatus,
  observationRequestStatus: RequestStatus,
  moderationState: ?ModerationState,
  subject: Product,
  ugc: Ugc,
  requestContent: () => void,
  requestObservationsUpdate: ModerationState => void,
  updateObservations: ModerationState => void,
  ugcId: UgcId,
};

class SecondOpinion extends React.PureComponent<SecondOpinionProps, void> {
  componentDidMount() {
    this.props.requestContent();
  }

  handleSubmit = (...args) => {
    this.props.requestObservationsUpdate(...args);
    this.props.requestContent();
  };

  render() {
    const {
      contentRequestStatus,
      observationRequestStatus,
      moderationState,
      subject: product,
      ugc,
      ugcId,
    } = this.props;
    return (
      <HideClientSelect>
        <div className={styles.secondOpinion}>
          <ContentRequest requestStatus={contentRequestStatus}>
            <ContentResponse
              ugcId={ugcId}
              requestContent={this.props.requestContent}
              moderationState={moderationState}
            >
              {moderationState && (
                <div
                  key={moderationState.getId()}
                  className={styles.secondOpinionCard}
                >
                  <PowerReviewsKeyboardEnchancer>
                    <PowerReviewsModerationCard
                      key={moderationState.getId()}
                      data-id={moderationState.getId()}
                      status={observationRequestStatus}
                      product={product}
                      ugc={ugc}
                      beforeSubmit={
                        ModerationState.completePowerReviewsModeration
                      }
                      moderationState={moderationState}
                      onSubmit={this.handleSubmit}
                      onChange={this.props.updateObservations}
                    />
                  </PowerReviewsKeyboardEnchancer>
                </div>
              )}
            </ContentResponse>
          </ContentRequest>
        </div>
      </HideClientSelect>
    );
  }
}

const mapStateToProps = (state: {
  secondOpinion: SecondOpinionReducerState,
  auth: { [string]: * },
  appConfig: { [string]: * },
  coreData: CoreDataState,
}) => {
  const { auth, appConfig, coreData, secondOpinion: session } = state;
  const ugcId = session.ugcId;

  return {
    token: auth.token,
    ugcId,
    ...CoreDataState.getTheThings(coreData, ugcId),
    observationsMap: appConfig.observationsMap,
    contentRequestStatus: session.contentRequestStatus,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        updateObservations,
        requestObservationsUpdate,
        requestContent,
      },
      dispatch
    ),
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { token, observationsMap, ...restStateProps } = stateProps;
  const { dispatch, ...restDispatchProps } = dispatchProps;

  return {
    ...ownProps,
    ...restStateProps,
    ...restDispatchProps,
    requestContent() {
      dispatch(requestContent({ token, observationsMap }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
  SecondOpinion
);



// WEBPACK FOOTER //
// ./src/pages/moderation/second-opinion/SecondOpinion.js